export function exhaustiveCheck(
  x: never,
  message: string = "Shouldn't be possible"
): never {
  throw new Error(message);
}
